"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var HrBoxComponent = function HrBoxComponent(props) {
  var left = props.left,
    leftClassName = props.leftClassName,
    middle = props.middle,
    middleClassName = props.middleClassName,
    right = props.right,
    rightClassName = props.rightClassName,
    _a = props.show,
    show = _a === void 0 ? true : _a;
  if (!show) {
    return null;
  }
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: 'odc-hr-box',
    supportAllEvents: true
  }, HrBoxComponent)), left && react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-hr-box-left', leftClassName)
  }, left), middle && react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-hr-box-middle', middleClassName)
  }, middle), right && react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-hr-box-right', rightClassName)
  }, right));
};
(0, spaui_utils_1.setComponentMark)(HrBoxComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(HrBoxComponent);